let hideCount = 0;
let originalDescriptor = null;

export function resetHiddenArraySuperForTests() {
  hideCount = 0;
  originalDescriptor = null;
}

export default function withHiddenArraySuper(run) {
  // PDF.js enumerates Array.prototype and trips Ember's `_super`
  // (mozilla/pdf.js#11412). Only toggle enumerable when the descriptor allows
  // it, and restore the original descriptor — `{ enumerable }` alone can
  // recreate `_super` as read-only and break later Ember mixins.
  //
  // Overlapping loads share one hide session. A later `loadRenderedPdf` sees
  // `_super` already non-enumerable, so it must join the in-flight count
  // instead of treating that as "nothing to hide" and skipping restore.
  let descriptor = Object.getOwnPropertyDescriptor(Array.prototype, '_super');
  let joining = hideCount > 0;
  let canHide = !!(descriptor?.enumerable && descriptor.configurable);

  if (!joining && !canHide) {
    return run();
  }

  if (canHide && hideCount === 0) {
    originalDescriptor = descriptor;
    Object.defineProperty(Array.prototype, '_super', { ...descriptor, enumerable: false });
  }

  hideCount += 1;

  let restore = () => {
    hideCount = Math.max(0, hideCount - 1);

    if (hideCount === 0 && originalDescriptor) {
      Object.defineProperty(Array.prototype, '_super', originalDescriptor);
      originalDescriptor = null;
    }
  };

  try {
    let result = run();

    if (result && typeof result.finally === 'function') {
      // Fire-and-forget callers (loadRenderedPdf) must keep a thenable, not an
      // async function, so payment afterPersist does not wait on PDF.js.
      // eslint-disable-next-line promise/prefer-await-to-then
      return result.finally(restore);
    }

    restore();
    return result;
  } catch (error) {
    restore();
    throw error;
  }
}
